export default __webpack_public_path__ + "153532ef1e3a1bd47cb922b16b4239a0.png";